import { render } from "./WebFormCompany.vue?vue&type=template&id=a447098c"
import script from "./WebFormCompany.vue?vue&type=script&lang=js"
export * from "./WebFormCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__